import api from '../api'

export default {
    namespaced: true,
    state: {
        withdrawAccountInfo: {// 申请提豆账号信息
        }
    },
    mutations: {
        setStateWithdrawAccountInfo(state, info) {
            state.withdrawAccountInfo = info
        }
    },
    actions: {
        getWithdrawAccountInfo({commit}, params) {
            return api.post('/withdrawChips/accountInfo', '获取提豆申请账号信息', params).then(res => {
                commit('setStateWithdrawAccountInfo', res.data)
            })
        },
        getWithdrawList(store, params) {
            return api.post('/withdrawChips/platform-list', '提豆订单查询', params).then(res => {
                return res.data
            })
        },
        getWithdrawTotal(store, params) {
            return api.post('/withdrawChips/platform/total', '提豆订单统计', params).then(res => {
                return res.data
            })
        }
    }
}